






































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { IProxyUserBan } from '@/interfaces';
import {
  dispatchGetProxyUserBans,
  dispatchDeleteProxyUserBans,
  dispatchDeleteProxyUserBan,
} from '@/store/admin/accessors';

@Component
export default class ProxyUserBans extends Vue {
  public search: string = '';
  public loading: boolean = false;
  public proxyUserBans: IProxyUserBan[] = [];
  public totalProxyUserBans: number = 0;

  public selected: IProxyUserBan[] = [];
  public pagination: { sortBy; descending; page; rowsPerPage; footerProps } = {
    sortBy: 'id',
    descending: false,
    page: 1,
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  private searchDelay: number | undefined;

  public get headers() {
    return [
      {
        text: 'Service',
        value: 'service_id',
        align: 'left',
      },
      {
        text: 'Phone',
        value: 'phone',
        align: 'left',
      },
      {
        text: '# of Bans',
        value: 'bans_counter',
        align: 'left',
      },
      {
        text: 'Proxy error',
        value: 'proxy_error_id',
        align: 'left',
      },
      {
        text: 'Additional info',
        value: 'additional_info',
        align: 'left',
      },
      {
        text: 'Ban expiration / Banned At',
        value: 'expiration_dt',
        align: 'left',
      },
      {
        text: 'Is Active',
        value: 'is_active',
        align: 'left',
      },
      {
        text: 'Is Permanent',
        value: 'is_permanent',
        align: 'left',
      },
      {
        text: 'Actions',
        value: 'id',
      },
    ];
  }

  public updateProxyUserBans() {
    this.loading = true;
    this.getDataFromApi().then((data) => {
      if (data) {
        this.totalProxyUserBans = data.total;
        this.proxyUserBans = data.items;
      }
    });
    this.loading = false;
  }

  public getDates(item: IProxyUserBan) {
    return `${new Date(item.expiration_dt).toLocaleString('de')} / ${new Date(item.banned_dt).toLocaleString('de')}`;
  }

  @Watch('pagination', { deep: true })
  public onPaginationChange(val) {
    this.updateProxyUserBans();
  }

  @Watch('search')
  public onSearchChange(val) {
    clearTimeout(this.searchDelay);
    this.searchDelay = setTimeout(this.updateProxyUserBans, 400);
  }

  public async mounted() {
    this.updateProxyUserBans();
  }

  public async deleteProxyUserBan(id: number) {
    if (confirm('Are you sure you want to delete this proxy user ban?')) {
      await dispatchDeleteProxyUserBan(this.$store, id);
      this.updateProxyUserBans();
    }
  }

  public async getDataFromApi() {
    const { sortBy, descending, page, rowsPerPage } = this.pagination;
    const skip = (page - 1) * rowsPerPage;
    return await dispatchGetProxyUserBans(this.$store, {
      skip,
      limit: rowsPerPage,
      orderBy: sortBy,
      descending,
      phoneQuery: this.search,
    });
  }

  public async deleteProxyUserBans() {
    if (confirm('Are you sure you want to delete selected proxy user bans?')) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteProxyUserBans(this.$store, selected);
      this.updateProxyUserBans();
    }
  }
}
